import { useTranslation } from '@/core/hooks';
import { useQuery } from '@tanstack/react-query';
import { fetchFaqs, fetchAdhaFaqs, FaqCategoryGroup } from '../services/faqService';

interface UseFaqsResult {
    categories: FaqCategoryGroup[];
    flattened: FaqCategoryGroup;
    isLoading: boolean;
    error: unknown;
}

export function useFaqs(isAdhaFlow?: boolean): UseFaqsResult {
    const { currentLanguage } = useTranslation();

    const query = useQuery({
        queryKey: ['faqs', currentLanguage, isAdhaFlow],
        queryFn: () => {
            const locale = currentLanguage === 'ar' ? 'ar' : 'en';
            return isAdhaFlow ? fetchAdhaFaqs(locale) : fetchFaqs(locale);
        },
        staleTime: 5 * 60 * 1000,
    });

    const categories = query.data || [];
    const flattened: FaqCategoryGroup = {
        category: 'All',
        items: categories.flatMap((c) => c.items),
    };

    return {
        categories,
        flattened,
        isLoading: query.isLoading,
        error: query.error,
    };
}

